import { Client } from '../types/enums';

export const DEV_HOST = 'localhost';
export const DEV_MACHINE = 'machine';

export const PREVIEW_CHANNEL = 'lernit-platform-qa.web.app';

export const EXPERIMENT_URL = 'experimentos.lapzo.mx';
export const EXPERIMENT_URL_2 = 'lapzoacademy.com';
export const EXPERIMENT_URL_3 = 'academia.lapzo.com';

export const DOMAIN = 'lernit.com.mx';

export const PREFIX = '-lernit';

export const CUSTOM_DOMAINS = {
  'execon-lernit.lernit.app': Client.EXECON,
  'lh.universidad.deacero.com': Client.DEACERO,
  'universidad.deacero.com': Client.DEACERO,
  'elearninghircasa.lapzo.app': Client.HIRCASA,
  'energizertraining.com': Client.ENERGIZER,
  'elearninghircasa.lapzo.mx': Client.HIRCASA,
  'academy.sqasa.co': Client.SQA,
  'sqacademy.sqasa.co': Client.SQA,
  'talento.penaranda.com.mx': Client.PENARANDA,
  'talenthos.lapzo.app': Client.TALENTOHOS,
  'universidadunicco.lapzo.app': Client.UNICCO,
  'odella-virtual-academy.lapzo.app': Client.OVERNIA_ZANEO,
  'odella-virtual-academy.lapzo.mx': Client.OVERNIA_ZANEO,
  'plataforma.bedu.org': Client.PLATAFORMABEDU,
  'plataforma-ai.bedu.org': Client.PLATAFORMABEDU_SANTANDER,
  'capacitacion.altesa.com.mx': Client.ALTESA,
  'academy.aplatam.com': Client.ACADEMYAP,
  'university.ferbelpowersports.com': Client.FERBEL,
  'universidadswartz.mx': Client.SWARTZ,
  'universidadepesa.com.py': Client.EPESA,
  'academy.evaluar.com': Client.EVALUAR_ACADEMY,
  'academy.magos.dev': Client.EVALUAR_ACADEMY,
  'app.evaluar.academy': Client.EVALUAR_ACADEMY,
  'courses.skillingcenter.com': Client.TECMILENIO,
  'gestiondetalentorendichicas.com': Client.RENDILITROS,
  'gruporendilitrosgestiondetalento.com': Client.UESFUEL,
  'capacitate.apelsa.net': Client.APELSA,
  'walmarteducaciontecmilenio.mx': Client.WALMARTEDUCACIONTECMILENIO,
  'educaciontecmilenio.mx': Client.WALMARTEDUCACIONTECMILENIO,
  'universidad.homesandliving.mx': Client.UNIVERSIDAD_HOMELIVING,
  'unilar.co': Client.UNILAR,
  'universidad.elpotosi.com.mx': Client.UNIVERSIDADPOTOSI,
  'universidadmazda.com': Client.MAZDA,
  'lapzomieducacion.com': Client.LAPZOMIEDUCACION,
  'crecemos.contactoenmedios.com': Client.CRECEMOS,
  'universidadzapata.com': Client.ZAPATA,
  'campusverdeverdad.com': Client.CAMPUSVERDEVERDAD,
  'universidadgrupotepeyac.gtepeyac.com': Client.UNIVERSIDADTEPEYAC,
  'universidad.omexalimentaria.mx': Client.OMEXALIMENTARIA,
  'universidadgayosso.com.mx': Client.GAYOSSO,
  'famelearning.mx': Client.FAMELEARNING,
  'unineto.soyneto.com': Client.SOY_NETO,
  'campusalfa.com': Client.CAMPUSALFA,
  'universidadgp.com': Client.UNIVERSIDADGP,
  // TLG
  'empresa.mylearningtec.mx': Client.EMPRESATLG,
  's4uni.com': Client.S4UNI,
  'grupomultiproseg.mx': Client.MULTIPROSEG,
  'academia-multiproseg.com': Client.MULTIPROSEG,
  'unitce.com': Client.CASAEXPRESS,
  'elearningkubota.com.mx': Client.KUBOTA,
  'tecnologico.hortifrut.com': Client.HORTIFRUT,
  'impulsate.gaya.mx': Client.IMPULSATE,
  'smsmedicalsolutionseducation.com': Client.SNSMEDICALSOLUTIONS,
  'capacitacion.indelpro.com': Client.INDELPRO,
  'academia.maguengroup.com': Client.MAGUENGROUP,
  'universidadtrimex.gtrimex.mx': Client.GTRIMEX,
  'aulavirtual.som.us': Client.AULAVIRTUAL,
  'impulsa.fevisa.com': Client.FEVISA,
  'miespaciopetro.grupopetro.com.mx': Client.GRUPO_PETRO,
  'konicaminoltalearning.mx': Client.KONICAMINOLTA,
  'universidad.arizlu.com': Client.ARIZLU,
  'desarrollo-dsi-tcs.advansec.com.mx': Client.CYBERSEC,
  'e360-dsi-tcs.advansec.com.mx': Client.CYBERSEC,
  'desarrollodetalento.miaa.mx': Client.MIAA,
};

export const TEST_DOMAIN = '.app';

export const SSO_PREFIX = '/sso/auth/inside--';
